export { default as _get } from "lodash/fp/get"
